<template>
	<div class="outer">
		<div class="inner" role="main">
			<slot />
		</div>
		<footer role="navigation">
			<ul>
				<li v-for="(link, key) in footer" :class="{ 'active': $route.path === link.to }">
					<NuxtLink :to="link.to" :key="key">{{ link.name }}</NuxtLink>
				</li>
			</ul>
		</footer>
	</div>
</template>

<script setup lang="ts">
import { footer } from '~/assets/config/navigation.json'
</script>

<style lang="css" scoped>
div.outer
{
	margin: 0 .6rem;
}

div.inner
{
	position: relative;
	width: 100%;
	max-width: 700px;
	box-sizing: border-box;
	background: rgb(var(--white));
	color: rgb(var(--black));
	border-radius: .7rem;
	margin: 120px auto 1rem;
	padding: 1.5rem 2rem;
	box-shadow: rgba(50, 50, 93, 0.25) 0px 30px 60px -12px, rgba(0, 0, 0, 0.3) 0px 18px 36px -18px;
	z-index: 10;
}

div :deep(h1)
{
	font-family: "brother-1816", sans-serif;
	color: rgb(var(--blue));
	font-size: 2.5rem;
	margin: 0;
	font-weight: 300;
	letter-spacing: .1rem;
}

div :deep(h2)
{
	font-family: "brother-1816", sans-serif;
	color: rgb(var(--blue));
	font-size: 1.75rem;
	margin: 1rem 0;
	font-weight: 300;
	letter-spacing: .1rem;
}

div :deep(h3)
{
	font-family: "brother-1816", sans-serif;
	color: rgb(var(--blue));
	font-size: 1.5rem;
	margin: 1rem 0;
	font-weight: 300;
	letter-spacing: .1rem;
}

footer
{
	position: relative;
	width: 100%;
	max-width: 700px;
	margin: 0 auto 3rem;
	z-index: 10;
}

footer ul
{
	display: flex;
	justify-content: center;
	list-style: none;
	margin: 0;
	padding: 0;
	gap: 1.25rem;
}

footer ul li
{
	flex: 0;
}

footer ul a
{
	color: rgb(var(--white));
	opacity: .6;
	text-decoration: none;
	transition: opacity .4s ease;
}

footer ul a:hover
{
	opacity: 1;
}

@media screen and (max-width: 500px)
{
	div.inner
	{
		padding: 1rem 1.3rem;
	}	
}
</style>